{
  "nl": {
    "pupilProjectStatus": {
      "switchError": "Fout bij het wisselen van project",
      "switchModal": {
        "joinAnotherClassroom": "Uitloggen en klaslokaal wisselen",
        "loading": "Beschikbare projecten worden geladen...",
        "noOtherProjects": "In dit klaslokaal zijn geen andere projecten beschikbaar.",
        "selectProject": "Je inhoud wordt in dit project opgeslagen:",
        "selectProjectPlaceholder": "Kies een project om te wisselen",
        "title": "Projecttoewijzing"
      },
      "changeProject": "Project wisselen",
      "logoutError": "Fout bij het uitloggen",
      "switchSuccess": "Project succesvol gewisseld"
    }
  }
}
